module.exports = __webpack_public_path__ + "static/media/trash-x.5345256f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/trash-x.svg
// module id = 7676
// module chunks = 0